import { apiRequest } from '../http.js'

export const statsApi = {
get: async (options = {}) => {
      const data = await apiRequest('/stats', options)
      return data
    },
    
    getPlatform: async (options = {}) => {
      return apiRequest('/stats/platform', options)
    },
    getStorageUsage: async ({ from, to } = {}, options = {}) => {
      const qs = new URLSearchParams()
      if (from) qs.set('from', from)
      if (to) qs.set('to', to)
      const suffix = qs.toString() ? `?${qs.toString()}` : ''
      const data = await apiRequest(`/stats/storage-usage${suffix}`, options)
      return data.usage || []
    },
    getTenantCosts: async ({ from, to } = {}, options = {}) => {
      const qs = new URLSearchParams()
      if (from) qs.set('from', from)
      if (to) qs.set('to', to)
      const suffix = qs.toString() ? `?${qs.toString()}` : ''
      return apiRequest(`/stats/tenant-costs${suffix}`, options)
    },
    getBetaHealth: async (options = {}) => {
      return apiRequest('/stats/beta-health', options)
    },
}
